import React, { FunctionComponent } from 'react';

export const Card: FunctionComponent<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  return (
    <div className="card bg-white border border-neutral">
      <div className={`card-body ${className}`}>{children}</div>
    </div>
  );
};
